/**
 * NOS-184: Is the signed-in user the platform admin?
 * Calls the is_platform_admin SECURITY DEFINER function (email whitelist).
 * Display gating only — the edge function re-verifies server-side.
 */
import { useEffect, useState } from "react"
import { supabase } from "@/lib/supabase"
import { useAuthStore } from "@/stores/authStore"

export function useIsPlatformAdmin(): boolean {
  const email = useAuthStore((s) => s.user?.email ?? null)
  const [isAdmin, setIsAdmin] = useState(false)

  useEffect(() => {
    if (!email) {
      setIsAdmin(false)
      return
    }
    let cancelled = false
    supabase
      .rpc("is_platform_admin", { user_email: email })
      .then(({ data }) => {
        if (!cancelled) setIsAdmin(data === true)
      })
    return () => {
      cancelled = true
    }
  }, [email])

  return isAdmin
}
